export interface FreeIconProps {
    color?: string;
    className?: string | null;
}

function FreeIcon({ color = 'currentColor', className = null }: FreeIconProps) {
    return (
        <svg
            width="60"
            height="30"
            viewBox="0 0 60 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className ?? undefined}
        >
            <path
                d="M30 0.5C38.2234 0.5 45.6434 2.16794 50.9893 4.84082C56.365 7.52871 59.5 11.1493 59.5 15C59.5 18.8507 56.365 22.4713 50.9893 25.1592C45.6434 27.8321 38.2234 29.5 30 29.5C21.7766 29.5 14.3566 27.8321 9.01074 25.1592C3.63496 22.4713 0.5 18.8507 0.5 15C0.5 11.1493 3.63496 7.52871 9.01074 4.84082C14.3566 2.16794 21.7766 0.5 30 0.5Z"
                fill="var(--color-page-background)"
                stroke={color}
            />
            <path
                d="M21.13 13.1906C19.0899 13.1906 17.84 11.7606 17.84 9.44059C17.84 7.11059 19.03 5.68059 20.93 5.68059C22.47 5.68059 23.55 6.69059 23.76 8.43059L22.21 8.66059C22.05 7.66059 21.57 7.12059 20.9299 7.12059C20.0499 7.12059 19.5299 8.00059 19.5299 9.44059C19.5299 10.8706 20.13 11.7306 21.13 11.7306C21.94 11.7306 22.52 11.0706 22.67 9.99059L24.25 10.2406C24.01 12.0506 22.82 13.1906 21.13 13.1906Z"
                fill={color}
            />
            <path
                d="M24.6382 8.83059L24.7382 8.45059C25.4882 8.65059 26.0982 8.10059 26.1482 7.22059C25.4282 7.59059 24.7482 7.15059 24.7482 6.49059C24.7482 5.99059 25.1282 5.63059 25.6182 5.63059C26.1782 5.63059 26.5682 6.10059 26.5682 6.95059C26.5782 8.31059 25.7582 9.10059 24.6382 8.83059Z"
                fill={color}
            />
            <path
                d="M27.3566 13.0006L27.3566 5.88059L31.4466 5.88059L31.4466 7.23059L28.9766 7.23059L28.9766 8.75059L31.0466 8.75059L31.0466 9.95059L28.9766 9.95059L28.9766 11.6506L31.5466 11.6506L31.5466 13.0006L27.3566 13.0006Z"
                fill={color}
            />
            <path
                d="M34.6396 13.2006C33.0096 13.2006 31.9496 12.2506 31.9196 10.7706L33.4796 10.5206C33.4796 11.3806 34.0096 11.9106 34.7196 11.9106C35.2996 11.9106 35.6796 11.5606 35.6796 11.0906C35.6796 10.6906 35.4296 10.4306 34.8096 10.2206L33.9396 9.94059C32.6796 9.56059 32.1396 8.93059 32.1396 7.83059C32.1396 6.56059 32.9896 5.68059 34.5396 5.68059C35.9496 5.68059 36.8896 6.50059 36.9196 7.81059L35.3996 8.10059C35.4096 7.40059 35.0296 6.95059 34.5096 6.95059C34.0396 6.95059 33.7196 7.27059 33.7196 7.71059C33.7196 8.13059 33.9596 8.39059 34.5996 8.58059L35.4296 8.86059C36.7096 9.25059 37.2696 9.86059 37.2696 10.9606C37.2696 12.2606 36.3296 13.2006 34.6396 13.2006Z"
                fill={color}
            />
            <path
                d="M38.9019 13.0006L38.9019 7.32059L37.2219 7.32059L37.2219 5.88059L42.2719 5.88059L42.2719 7.32059L40.5919 7.32059L40.5919 13.0006L38.9019 13.0006Z"
                fill={color}
            />
            <path
                d="M11.8467 22.1806C9.96675 22.1806 8.80675 20.7606 8.80675 18.4406C8.80675 16.1106 10.0467 14.6806 12.0667 14.6806C13.4367 14.6806 14.5067 15.5106 14.8767 16.8706L13.2967 17.2106C13.0867 16.5306 12.6167 16.1206 12.0467 16.1206C11.0867 16.1206 10.4967 16.9806 10.4967 18.4006C10.4967 19.8506 11.1667 20.7406 12.2567 20.7406C13.2267 20.7406 13.8267 20.1106 13.8567 19.0606L11.6467 19.0606L11.6467 17.9606L15.4667 17.9606L15.4667 22.0006L14.2267 22.0006L14.1267 20.8906L14.1167 20.8906C13.6467 21.6906 12.7867 22.1806 11.8467 22.1806Z"
                fill={color}
            />
            <path
                d="M20.7526 22.1806C20.0526 22.1806 19.6326 21.7306 19.5026 21.1106L19.2026 19.8406C19.1126 19.4906 18.8426 19.2506 18.5526 19.2506L17.9526 19.2506L17.9526 22.0006L16.2726 22.0006L16.2726 14.8806L19.0126 14.8806C20.6026 14.8806 21.6226 15.7506 21.6226 17.1206C21.6226 17.9606 21.1126 18.7106 20.2526 18.9506L20.2526 18.9606C20.6126 19.1206 20.7626 19.4206 20.8426 19.7806L21.0526 20.7006C21.0926 20.9106 21.1826 21.0306 21.3226 21.0306C21.4326 21.0306 21.5526 20.9806 21.6826 20.8006L22.0826 21.6106C21.7526 21.9606 21.2426 22.1806 20.7526 22.1806ZM17.9526 18.0706L18.9226 18.0706C19.5226 18.0706 19.9326 17.6906 19.9326 17.1206C19.9326 16.5006 19.5326 16.1506 18.9226 16.1506L17.9526 16.1506L17.9526 18.0706Z"
                fill={color}
            />
            <path
                d="M22.2393 22.0006L24.2893 14.8806L26.3993 14.8806L28.4593 22.0006L26.7693 22.0006L26.4193 20.5906L24.2693 20.5906L23.8993 22.0006L22.2393 22.0006ZM24.5093 19.3706L26.1793 19.3706L25.3693 16.2706L25.3493 16.2706L24.5093 19.3706Z"
                fill={color}
            />
            <path
                d="M29.5757 22.0006L29.5757 16.3206L27.8957 16.3206L27.8957 14.8806L32.9457 14.8806L32.9457 16.3206L31.2657 16.3206L31.2657 22.0006L29.5757 22.0006Z"
                fill={color}
            />
            <path
                d="M36.2378 22.2006C34.4978 22.2006 33.4978 21.2806 33.4978 19.7006L33.4978 14.8806L35.1878 14.8806L35.1878 19.5706C35.1878 20.3206 35.5778 20.7606 36.2378 20.7606C36.8978 20.7606 37.2878 20.3206 37.2878 19.5606L37.2878 14.8806L38.9678 14.8806L38.9678 19.7006C38.9678 21.2806 37.9678 22.2006 36.2378 22.2006Z"
                fill={color}
            />
            <path
                d="M39.8468 22.0006L39.8468 14.8806L41.5268 14.8806L41.5268 22.0006L39.8468 22.0006Z"
                fill={color}
            />
            <path
                d="M43.814 22.0006L43.814 16.3206L42.134 16.3206L42.134 14.8806L47.184 14.8806L47.184 16.3206L45.504 16.3206L45.504 22.0006L43.814 22.0006Z"
                fill={color}
            />
            <path
                d="M49.7881 19.8306L49.4081 16.8006L49.4081 14.8806L50.9681 14.8806L50.9681 16.8006L50.5781 19.8306L49.7881 19.8306ZM50.1781 22.1206C49.6581 22.1206 49.2781 21.7506 49.2781 21.2406C49.2781 20.7306 49.6581 20.3706 50.1781 20.3706C50.7081 20.3706 51.0781 20.7306 51.0781 21.2406C51.0781 21.7506 50.7081 22.1206 50.1781 22.1206Z"
                fill={color}
            />
        </svg>
    );
}

export default FreeIcon;
